module.exports = __webpack_public_path__ + "img/01-05-1440-560.7860b728.png";